import type { MappedServiceData } from "@/features/flights/components/flight-purchase/AdditionalServicesSelection/types";
import type { GetFlightAvailabilityTokenFlightV2 } from "@/types/codegen";

export const getCityNameByAirportCode = (
  cityCode?: string,
  flights?: GetFlightAvailabilityTokenFlightV2[],
) => {
  const segment = flights
    ?.flatMap((f) => f.segments)
    .find(
      (s) =>
        s.departure.airport.code === cityCode ||
        s.arrival.airport.code === cityCode,
    );

  const cityName =
    segment?.departure.airport.code === cityCode
      ? segment?.departure.city.name
      : segment?.arrival.airport.code === cityCode
        ? segment?.arrival.city.name
        : undefined;

  return cityName || cityCode;
};

export const mapServicesToRoutes = (
  services: MappedServiceData[],
  allowedServicesCode?: string[],
) => {
  const filteredServices = allowedServicesCode
    ? services.filter((s) =>
        allowedServicesCode.includes(s.service.service.categoryCode),
      )
    : services;
  return filteredServices.reduce(
    (acc, serviceData) => {
      const routeKey = `${serviceData.service.route.departureCode} - ${serviceData.service.route.arrivalCode}`;
      if (!acc[routeKey]) {
        acc[routeKey] = [];
      }
      acc[routeKey].push(serviceData);
      return acc;
    },
    {} as Record<string, MappedServiceData[]>,
  );
};
